import { useEffect, useState } from 'react'

export type InAppPlatform = 'android' | 'ios' | 'unknown'

interface InAppBrowserState {
  detected: boolean
  isWhatsApp: boolean
  platform: InAppPlatform
}

export function useInAppBrowserRedirect(): InAppBrowserState {
  const [state, setState] = useState<InAppBrowserState>({
    detected: false,
    isWhatsApp: false,
    platform: 'unknown',
  })

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera

    const isAndroid = /Android/i.test(ua)
    const isIOS = /iPhone|iPad|iPod/i.test(ua)
    const isMobile = isAndroid || isIOS

    // Only relevant on actual mobile devices — WhatsApp desktop doesn't have an in-app browser
    if (!isMobile) {
      return
    }

    const whatsAppPatterns = [/WhatsApp/i, /WA_IAB/i, /WAWebView/i, /WAiOS/i]
    const otherInAppPatterns = [
      /FBAN/i,
      /FBAV/i,
      /FB_IAB/i,
      /Instagram/i,
      /Messenger/i,
      /WebView/i,
      /Line/i,
      /Tiktok/i,
      /WeChat/i,
      /MicroMessenger/i,
      /UCBrowser/i,
    ]

    const isWhatsApp = whatsAppPatterns.some((p) => p.test(ua))
    const isDetected = isWhatsApp || otherInAppPatterns.some((p) => p.test(ua))

    const platform: InAppPlatform = isAndroid ? 'android' : 'ios'

    setState({ detected: isDetected, isWhatsApp, platform })

    // On Android, attempt to open in the default external browser via intent URL.
    // The overlay is still shown as fallback if the intent fails (e.g. no browser installed).
    if (isDetected && isAndroid) {
      const url = window.location.href
      const intentUrl = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;end`
      window.location.href = intentUrl
    }
  }, [])

  return state
}
